import * as React from 'react';
import Select from 'react-select';
import * as uniqid from 'uniqid';

export interface IValueLabelPair {
  value: string;
  label: string;
}

interface ISelectProps {
  name: string;
  label?: string;
  options: IValueLabelPair[];
  placeholder?: string;
  required?: boolean;
  clearFilterDisabled?: boolean;
  onChange?: (e: any) => void;
  value?: string;
  disabled?: boolean;
}

interface ISelectState {
  selected: IValueLabelPair;
}

class SelectInput extends React.Component<ISelectProps> {
  public props: ISelectProps;
  public state: ISelectState;

  constructor(props: ISelectProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);

    let selected: any;
    if (!this.props.placeholder) {
      selected = props.options && props.options[0];
    }

    if (props.value) {
      const option = props && props.options 
        ? props.options.find(o => o.value === props.value) 
        : undefined;

      if (option) {
        selected = option;
      }
    }

    this.state = {
      selected
    };
  }

  private handleChange(selected: any) {
    this.setState({ selected });
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: selected
        }
      });
    }
  }

  public componentWillReceiveProps(nextProps: ISelectProps) {
    if (nextProps && nextProps.value) {
      const option = nextProps && nextProps.options 
        ? nextProps.options.find(o => o.value === nextProps.value) 
        : undefined;

      if (option) {
        this.setState({
          selected: option
        });
      }
    }
  }

  public render() {
    const { name, placeholder, required, label, disabled } = this.props;
    const options = this.props && this.props.options 
      ? [...this.props.options] 
      : [];
    const { selected } = this.state;
    const value = selected && selected.value;

    if (this.state.selected) {
      if (this.state.selected.value != undefined && !this.props.clearFilterDisabled) {
        options.unshift({ label: 'Clear filter', value: '' });
      }
    }

    const Id = uniqid('textarea-');

    return (
      <React.Fragment>
        {label &&
          <label htmlFor={Id} className={`label${required === true ? ' required' : ''}`}>{label}</label>}
        <Select
          disabled={disabled}
          searchable={true}
          clearable={false}
          placeholder={`${placeholder} ${required ? '*' : ''}`}
          name={name}
          value={value}
          onChange={this.handleChange}
          options={options}
        />
      </React.Fragment>
    );
  }
}

export default SelectInput;



// WEBPACK FOOTER //
// ./src/modules/Form/Select.tsx